export const UnsafeContactIcon = () => {
  return (
    <svg
      data-name="Grupo 7100"
      height="30.769"
      id="Grupo_7100"
      viewBox="0 0 37.382 35.769"
      width="32.382"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="9.648"
        cy="9.648"
        data-name="Elipse 1843"
        fill="#ff715b"
        id="Elipse_1843"
        rx="9.648"
        ry="9.648"
        transform="translate(5.644 0)"
      />
      <path
        d="M904.279,723.5v-.19a24.362,24.362,0,0,0,.1-2.6v-2.761a3.714,3.714,0,0,1,1.777-3.4.992.992,0,0,0-.317.159,11.833,11.833,0,0,1-13.616,0,1.24,1.24,0,0,0-1.428,0c-5.4,3.586-6.919,10.537-6.919,10.537s-1.4,5.713,4.253,5.713H907.77A9.14,9.14,0,0,1,904.279,723.5Z"
        data-name="Trazado 4393"
        fill="#ff715b"
        id="Trazado_4393"
        transform="translate(-883.718 -695.194)"
      />
      <path
        d="M958.457,721.542v-2.857a.589.589,0,0,1,.444-.635h.159a9.147,9.147,0,0,0,5.649-2.063c.508-.317.508-.317,1.016,0a11.431,11.431,0,0,0,5.649,2.063.589.589,0,0,1,.635.444v.159c0,2.063,0,4.126-.1,6.284a5.7,5.7,0,0,1-2.38,4.412,16.643,16.643,0,0,1-4.126,2.38.487.487,0,0,1-.508,0,22.61,22.61,0,0,1-4.126-2.253,6.138,6.138,0,0,1-2.476-5.047,18.623,18.623,0,0,0,.159-2.888Zm6.792,3.015,1.746,1.746c.317.317.635.317.825.1a.546.546,0,0,0-.032-.762l-.063-.063-1.555-1.555a.659.659,0,0,1-.19-.317c.19-.19.413-.317.508-.508a13.207,13.207,0,0,0,1.333-1.333.583.583,0,0,0-.825-.825l-.19.19-1.555,1.555a.275.275,0,0,0-.19-.1L963.5,721.13a.584.584,0,0,0-.825.825l.19.19,1.555,1.555-.317.317-1.555,1.555a.584.584,0,0,0,.825.825h0l.19-.19Z"
        fill="#ff715b"
        id="Trazado_3297_00000076589961736346650360000009045211211940409730_"
        transform="translate(-934.627 -696.056)"
      />
    </svg>
  );
};
